import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { useGetVehicleInfo } from "../../../../queries/useGetVehicleInfo";
import { usePanelState } from "../../../../stores/hooks/usePanelState";
import { Collapsible } from "../../../../ui/CollapsiblePannel/Collapsible";
import { RadioButton } from "../../../../ui/RadioButton/RadioButton";
import { useTireSeason } from "../../../Tires/Results/Filters/TireSeasonFilters/useTireSeason";

export const Season: FunctionComponent = () => {
  const { t } = useTranslation();
  const [panelIsOpen, togglePanel] = usePanelState(
    "dealer-package-season-panel",
    true
  );
  const [selectedSeazon, setSeason] = useTireSeason();
  const { data: info } = useGetVehicleInfo();
  const selectedSeason =
    info?.partListSummary?.seasonList.find(
      ({ season }) => season === selectedSeazon
    )?.season || 0;
  const seasonList = info?.partListSummary?.seasonList || [];
  return (
    <Collapsible
      className=" space-y-2"
      id="season-select"
      label={t("searchResults.season")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {!seasonList.length && t("searchResults.noSeasons")}
      {seasonList.map(({ season }) => (
        <label className="flex items-center gap-x-4" key={season}>
          <RadioButton
            onChange={(): void => {
              setSeason(season);
            }}
            checked={season === selectedSeason}
            checkedClassName="text-selected-tab"
            name="season"
            value={season}
          />
          <span className="flex-1 w-full">{t(`season.${season}`)}</span>
        </label>
      ))}
    </Collapsible>
  );
};
